var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"toggleable":"sm","type":"light","variant":"light"}},[_c('b-navbar-nav',{staticClass:"mr-auto"},[_vm._t("extras")],2),_c('b-navbar-nav',{staticClass:"ml-auto"},[_vm._t("items")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }